import request from './axiosClient';

const URL_SHOP_SETTING = '/shop-settings';
const URL_LOG = '/log-app-ranking';
const URL_PERMISSION_STAFF = '/add-many-shop-permissions-staff';
const URL_PERMISSION = '/permissions-by-user';
export function fetchShopSettingAPI(token: string, params: { shop_id: number }) {
  return request({
    url: URL_SHOP_SETTING,
    method: 'get',
    params,
    token,
  });
}
export function updateShopSettingsAPI(token: string, data: any) {
  return request({
    url: URL_SHOP_SETTING,
    method: 'post',
    data,
    token,
  });
}
export function fetchLogSettingAPI(
  token: string,
  params: {
    shop_ids: Array<number>;
    shop_id?: number;
    type_get: string;
    type: Array<string | number>;
    date: string;
  }
) {
  return request({
    url: URL_LOG,
    method: 'get',
    params,
    token,
  });
}
export function updatePermissionStaffAPI(
  token: string,
  data: {
    permission: Array<{
      name: string;
      active: number;
      app_name: Array<number>;
      shop_id: number;
      id?: number;
    }>;
  }
) {
  return request({
    url: URL_PERMISSION_STAFF,
    method: 'post',
    data,
    token,
  });
}
export function getPermissionByUserAPI(token: string) {
  return request({
    url: URL_PERMISSION,
    method: 'get',
    token,
  });
}
